import { TableController } from './actTable.controller';
import { DirectiveBase } from '../../angular-directive-base.directive';

/**
 * A directive to add additional functionality and styling to tables
 */
export class Table extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.transclude = {
      actions: '?actionsContainer',
      table: 'tableContainer'
    };
    this.scope = {
      filterCallback: '=',
      filterText: '@',
      selected: '=',
      currentFilter: '=?'
    };
    this.templateUrl = 'app/angularJS/components/table/act-table/actTable.html';
    this.controller = TableController;
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}